//
//
//
//
//
//
//

import QfMRichEditor from "./qf-m-rich-editor";

export default {
    name: "QfPRichEditor",
    components: { QfMRichEditor },
    props: ["value"],
    data() {
        return {
            showModal: false,
            localValue: null,
            currentEdit: null,
            removing: false
        };
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        }
    },
    methods: {
        onEditContent() {
            this.showModal = true;
        },
        onUpdate(content) {
            this.$emit("input", content);
        }
    }
};
